import * as React from "react"
// import { graphql, useStaticQuery } from "gatsby"
import Layout from "../components/layout/layout"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import CssBaseLine from "@mui/material/CssBaseline"
import SlidingMenu from "../components/slidingmenu"
import Header from "../components/header/header"

const IndexPage = () => {
  const [isMenuVisible, setMenuVisible] = React.useState(false)

  React.useEffect(() => {
    if (isMenuVisible) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "auto"
    }
  }, [isMenuVisible, setMenuVisible])

  // const data = useStaticQuery(graphql`
  //   query {
  //     allProjectsJson {
  //       edges {
  //         node {
  //           slug
  //           title
  //           code_url
  //           demo_url
  //           description
  //           image {
  //             childImageSharp {
  //               gatsbyImageData(width: 1024)
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // `)

  const globalTheme = createTheme({})

  // const projects = data?.allProjectsJson?.edges;

  const handleClick = () => {
    setMenuVisible(!isMenuVisible)
  }

  return (
    <ThemeProvider theme={globalTheme}>
      <CssBaseLine />
      <Header onClick={handleClick} isMenuVisible={isMenuVisible} />
      <Layout>
        <SlidingMenu onClick={handleClick} isMenuVisible={isMenuVisible} />

        <div style={{
          display: "flex",
          border: '1px solid red',
          width: '100vw',
          height: '100vh',
        }}></div>

        <div class="div1" data-sal="slide-up" data-sal-duration="2000">
          <img
            class="img1"
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ634CFs8rSXT2UCntcvX3eYuYpvkZXWsLs_A&usqp=CAU"
            alt="wdw"
          />
          <p>My new portfolio site.</p>
          <p>
            Build with best technologies: React, Material UI and the power of
            Gatsby.
          </p>
          <img
            class="img2"
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ634CFs8rSXT2UCntcvX3eYuYpvkZXWsLs_A&usqp=CAU"
            alt="wdw"
          />
        </div>

        <div class="div1" data-sal="slide-right" >
          <img
            class="img1"
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ634CFs8rSXT2UCntcvX3eYuYpvkZXWsLs_A&usqp=CAU"
            alt="wdw"
          />
          <p>My new portfolio site.</p>
          <p>
            Build with best technologies: React, Material UI and the power of
            Gatsby.
          </p>
          <img
            class="img2"
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ634CFs8rSXT2UCntcvX3eYuYpvkZXWsLs_A&usqp=CAU"
            alt="wdw"
          />
        </div>

        <div class="div1" data-sal="slide-left" data-sal-duration="2000">
          <img
            class="img1"
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ634CFs8rSXT2UCntcvX3eYuYpvkZXWsLs_A&usqp=CAU"
            alt="wdw"
          />
          <p>My new portfolio site.</p>
          <p>
            Build with best technologies: React, Material UI and the power of
            Gatsby.
          </p>
          <img
            class="img2"
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ634CFs8rSXT2UCntcvX3eYuYpvkZXWsLs_A&usqp=CAU"
            alt="wdw"
          />
        </div>
      </Layout>
    </ThemeProvider>
  )
}

export default IndexPage
